import classNames from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC, Fragment } from 'react'

import { capitalize } from '../../../utils/strings'
import styles from './BreadcrumbBar.module.css'

type Props = {
  hide?: Set<string>
  className?: string
}

const BreadcrumbBar: FC<Props> = props => {
  const router = useRouter()

  const routeParts = router.asPath
    .split('/')
    .filter(x => x)
    .map(x => decodeURIComponent(x))

  const breadcrumbs = ['Home', ...routeParts]
    .map(x => x.split(/[-_]/g).map(capitalize).join(' '))
    .map(
      (breadcrumb, index) =>
        !props?.hide?.has(breadcrumb) && (
          <Fragment key={index}>
            <div>
              <Link href={`/${routeParts.slice(0, index).join('/')}`}>
                <a className={styles.crumb}>{breadcrumb}</a>
              </Link>
              {index !== routeParts.length ? <span className={classNames(styles.crumb, styles.crumbIcon)}>»</span> : null}
            </div>
          </Fragment>
        )
    )

  return <div className={classNames(styles.bar, props.className)}>{breadcrumbs}</div>
}

export default BreadcrumbBar
